export const frTranslation = {
  header: {
    homeProjectors: "Projecteurs de salon",
    portableProjectors: "Projecteurs portables",
    support: "Support",
    promotion: "Promotion",
    dropdownHome: "Modèles de projecteurs de salon et accessoires",
    dropdownPortable: "Modèles de projecteurs portables et batteries externes",
    dropdownSupport: "FAQ, manuels et informations de contact",
  },
  main: {
    fastSelfHelpSupport: "Auto-assistance rapide",
    card1: {
      title: "Questions avant-vente",
      description: "Comment acheter avec une grosse remise ?",
      link: "En savoir plus",
    },
    card2: {
      title: "Support produit",
      description: "Vous avez des difficultés à utiliser votre projecteur ?",
      link: "Sélectionnez votre modèle",
    },
    card3: {
      title: "Service après-vente",
      description: "Garantie, politique de retour et d'échange",
      link: "En savoir plus",
    },
    getSupport: {
      title: "Obtenez notre soutien",
      replyTime: "Nous répondons généralement en 1 jour ouvrable.",
      checkFaq:
        "En cas de problème avec l'appareil, veuillez d'abord consulter le {faqLink}",
    },
  },
  form: {
    name: "Nom",
    email: "E-mail",
    order_id: "Votre numéro de commande",
    orderNumberHelp: "Comment trouver mon numéro de commande ?",
    describeIssue: "Veuillez décrire le problème",
    descriptionHelp:
      "Veuillez fournir autant de photos et de vidéos du défaut que possible afin que nous puissions déterminer rapidement la solution.",
    fileUpload: "Téléchargement de fichiers",
    fileUploadInstructions:
      "{action} des fichiers dans cette zone pour les télécharger.",
    fileUploadInstructionsAction: "Cliquez ou glissez",
    fileUploadLimit: "Vous pouvez télécharger jusqu'à 5 fichiers.",
    filesSelected: "{{count}}/5 fichiers sélectionnés.",
    maxFilesError: "Vous pouvez télécharger un maximum de 5 fichiers.",
    surveyTitle:
      "Un petit sondage - Quelles améliorations souhaiteriez-vous pour votre prochain projecteur ?",
    surveyPlaceholder: "ex : je veux qu'il soit plus lumineux, plus fort, etc.",
    submit: "Soumettre",
    nextButton: "Suivant",
    previousButton: "Précédent",
    submitSuccess: "Ticket de support soumis ! Nous vous répondrons bientôt.",
    step2: {
      expectation: {
        label: "Est-ce que ça répond à vos attentes ?",
        optionYes: "Oui, ça fonctionne bien",
        optionNo: "Non, il y a des problèmes",
      },
      rating: {
        label: "Comment l'évaluez-vous ?",
      },
      features: {
        label:
          "Un petit sondage - Quelles caractéristiques de nos produits vous attirent le plus ?",
        placeholder:
          "Par exemple : apparence, prix abordable, design unique, etc.",
      },
    },
    step3: {
      title: "Veuillez réclamer votre cadeau d'activation ! C'est gratuit !",
      gift1Title: "1 an de garantie supplémentaire",
      gift2Title: "Remplacement gratuit pendant 180 jours",
      confirmation:
        "Nous enverrons un e-mail de confirmation à votre boîte de réception, veuillez confirmer la réception dans l'e-mail.",
      activateButton: "Activer maintenant",
    },
    step4: {
      title: "Vous avez activé votre garantie avec succès !",
      line1:
        "J'espère que vous aimez le cadeau d'activation que nous avons préparé pour vous.",
      line2:
        "Vous avez reçu un e-mail de confirmation. Veuillez vérifier votre boîte de réception pour confirmer les avantages que vous avez sélectionnés.",
      line3:
        "Si vous ne le trouvez pas, vérifiez votre dossier de courrier indésirable.",
    },
    errors: {
      nameRequired: "Le nom est requis.",
      emailRequired: "L'e-mail est requis.",
      emailInvalid: "L'e-mail est invalide.",
      order_idRequired: "Le numéro de commande est requis.",
      order_idInvalid:
        "Format du numéro de commande invalide (ex: XXX-XXXXXXX-XXXXXXX).",
      commentRequired: "Veuillez décrire le problème.",
      filesRequired: "Au moins un fichier est requis.",
      surveyRequired: "Le champ du sondage est obligatoire.",
      expectationRequired: "Veuillez sélectionner une option.",
      ratingRequired: "Veuillez fournir une évaluation.",
      featuresRequired: "Ce champ de sondage est obligatoire.",
      giftRequired: "Veuillez sélectionner un cadeau à activer.",
    },
  },
  footer: {
    newsletterTitle: "Rejoignez notre newsletter",
    newsletterDescription:
      "Inscrivez-vous à notre newsletter pour recevoir des nouvelles de produits personnalisées, des mises à jour et des invitations spéciales",
    emailPlaceholder: "Adresse e-mail",
    signUp: "S'inscrire",
    products: "Produits",
    support: "Support",
    contactUs: "Contactez-nous",
    preSales: "Questions avant-vente",
    productSupport: "Support produit",
    afterSales: "Service après-vente",
    contactInfo: "Informations de contact",
    workingHours: "(CST) : Lun-Dim 9h-19h",
  },
  contactUs: {
    title: "Contactez-nous",
    description: "Si votre projecteur a des problèmes que vous ne pouvez pas résoudre, veuillez nous contacter à temps et remplir le formulaire. Nous vous répondrons dans les 24 heures pour vous aider à le résoudre. Vous pouvez également nous contacter en ligne de 18h30 à 6h30 (heure du Pacifique).",
    email: "Email",
    emailAddress: "vip_service@elephas.com.hk",
    phone: "Tél(US)",
    phoneNumber: "+1 (561) 309-3306",
    workingHours: "Lun-Ven 9h00-17h00 (PT)",
    form: {
      name: "Nom",
      email: "Email",
      country: "Pays",
      productModel: "Modèle de produit",
      amazonOrderNumber: "Numéro de commande Amazon",
      problemsEncountered: "Problèmes rencontrés",
      problemsPlaceholder: "Veuillez décrire les problèmes que vous avez rencontrés...",
      submit: "Soumettre",
      submitting: "Envoi en cours...",
      submitSuccess: "Merci ! Votre message a été envoyé avec succès. Nous vous répondrons dans les 24 heures.",
      errors: {
        nameRequired: "Le nom est requis.",
        emailRequired: "L'email est requis.",
        emailInvalid: "Veuillez entrer une adresse email valide.",
        countryRequired: "Le pays est requis.",
        amazonOrderNumberRequired: "Le numéro de commande Amazon est requis.",
      },
    },
  },
};
